import { MappedClass, MappedProperty, MappedPropertyClass } from '@h5s/util-object';
import { CashRegisterType } from './cash-register-type';
import { CashRegisterStatus } from './cash-register-status';

@MappedClass()
export class CashRegister {
  @MappedProperty()
  id: number;

  @MappedProperty()
  ownerCorporateDataId: number;

  @MappedProperty()
  description: string;

  @MappedPropertyClass(() => CashRegisterType)
  cashRegisterType: CashRegisterType;

  @MappedProperty()
  address: string;

  @MappedProperty()
  port: string | null;

  @MappedProperty()
  username: string | null;

  @MappedProperty()
  localAddress: string | null;

  @MappedProperty()
  invoiceBlocks: string[];

  @MappedProperty()
  doubleCopy: boolean;

  status: CashRegisterStatus;
}
